/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Agent_Run_Approval_Expired_OnInputs */



/**
* | output |
* | --- |
* | "This approval expired on {date}; nothing was run. Start the run again to retry." |
*
* @param {Agent_Run_Approval_Expired_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_approval_expired_on = /** @type {((inputs: Agent_Run_Approval_Expired_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Approval_Expired_OnInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Diese Freigabe ist am ${i?.date} abgelaufen; es wurde nichts ausgeführt. Starten Sie den Lauf erneut, um es noch einmal zu versuchen.`)
	return /** @type {LocalizedString} */ (`This approval expired on ${i?.date}; nothing was run. Start the run again to retry.`)
});